import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'se-text-editor-menu-select',
  templateUrl: './se-text-editor-menu-select.component.html',
  styleUrls: ['./se-text-editor-menu-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: SeTextEditorMenuSelectComponent,
    multi: true
  }]
})
export class SeTextEditorMenuSelectComponent implements ControlValueAccessor {
  @Input() items: any[];
  @Input() tooltip: string;
  @Input() maxWidth = '180px';

  disabled: boolean;
  value: any;

  private onChangeFn: any;

  onSelectionChange(value: any) {
    if (this.onChangeFn) {
      this.onChangeFn(value);
    }
  }

  // ControlValueAccessor implementation

  writeValue(obj: any): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
      // vuota
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
